<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">SRI LANKA TEST PAGE</h2>
            <p class="tw-italic tw-text-gray-700">
                TEST PAGE
            </p>
        </b-container>

        <hr />

        <b-container fluid class="tw-my-5">
            <b-row>
                <b-col>{{ response_data }}</b-col>
            </b-row>
        </b-container>

        <hr />
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    data() {
        return {
            response_data: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.find();
    },
    methods: {
        find() {
            const that = this;
            HTTP.get(`/srilanka/hello`, {
                params: {},
            })
                .then((response) => {
                    that.response_data = response.data;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
    },
};
</script>
